import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 15,
	viewBox: "0 0 16 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.00004 1.33325L10.06 5.50792L14.6667 6.17725L11.3334 9.42659L12.12 14.0146L8.00004 11.8479L3.88004 14.0146L4.66671 9.42659L1.33337 6.17725L5.94004 5.50792L8.00004 1.33325Z",
		fill: "#FF9500",
		stroke: "#FF9500",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})
});
export default SvgStarFilled;
